import { Observable, of } from 'rxjs';
import { startWith, catchError, map } from 'rxjs/operators';
import { StatedData } from './stated-data';

export function statedStream<T>(
  toCall: Observable<T>,
  initialValue?: T,
): Observable<StatedData<T>> {
  return toCall.pipe(
    map(result => {
      const data: StatedData<T> = {
        isLoading: false,
        isLoaded: true,
        hasError: false,
        error: undefined,
        result,
      };
      return data;
    }),
    startWith({
      isLoading: true,
      isLoaded: false,
      hasError: false,
      error: undefined,
      result: initialValue,
    } as const),
    catchError(error =>
      of({
        isLoading: false,
        isLoaded: false,
        hasError: true,
        error,
        result: undefined,
      } as const),
    ),
  );
}

export function emptyStatedData<T>(initialValue?: T) {
  return {
    isLoading: false,
    isLoaded: true,
    hasError: false,
    error: undefined,
    result: initialValue,
  } as const;
}

export function emptyLoadingStatedData<T>(initialValue?: T) {
  return {
    isLoading: true,
    isLoaded: false,
    hasError: false,
    error: undefined,
    result: initialValue,
  } as const;
}
